import { render, staticRenderFns } from "./SpecialOffer.vue?vue&type=template&id=1ad2ebf4&"
import script from "./SpecialOffer.vue?vue&type=script&lang=ts&"
export * from "./SpecialOffer.vue?vue&type=script&lang=ts&"
import style0 from "./special_offer.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports